export const services = [
  {
    id: 1,
    slug: "indkoersel",
    title: "Indkørsel",
    shortDescription: "Holdbare og smukke indkørsler, der komplementerer din boligs arkitektur.",
    fullDescription: "En indkørsel er det første, dine gæster møder, og den skal kunne modstå daglig belastning fra biler i mange år. Jeg har stor erfaring med alt fra klassiske herregårdssten to moderne store fliser og chaussésten. Jeg sikrer altid et korrekt underlag, så din indkørsel ikke sætter sig med tiden.",
    icon: "Car",
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/c44311e0-ab36-48d7-b71e-cf49ea50338d.jpg", // IMG_20260402_141641344.jpg
    features: ["Korrekt bundopbygning", "Præcis kantafgrænsning", "Mange sten-typer", "Lang holdbarhed"],
    gallery: [
      "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/bd078cb6-69a2-4457-8521-8c9349fd5f0c.jpg", // IMG_20260328_182436140_HDR.jpg
      "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/1570738f-fb1f-4b93-bb10-a902da24c142.jpg", // IMG_20260102_134816516.jpg
      "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/4423a5b0-6d79-432f-9a1e-1ea914ba712d.jpg", // IMG_20260102_134812183_HDR.jpg
      "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/184f5678-e82f-4a76-abd6-73a91f35f0c4.jpg", // IMG_20260102_134804410_HDR.jpg
      "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/97b85d20-2fe2-44cb-bc04-9e4ed52f4054.jpg"  // IMG_20260102_134756258_HDR.jpg
    ]
  },
  {
    id: 2,
    slug: "terrasse",
    title: "Terrasse",
    shortDescription: "Få drømmeterrassen i sten eller fliser, perfekt til sommeraftener og hygge.",
    fullDescription: "Terrassen er hjemmets ekstra leverum i de varme måneder. Uanset om du drømmer om en solrig krog til morgenkaffen eller en stor fladeterrasse til grillfester, designer og anlægger jeg den perfekte løsning. Jeg rådgiver personligt om materialevalg, der matcher både husets stil og dit vedligeholdelsesniveau.",
    icon: "Sun",
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/c9bc5107-9e56-4f64-acbc-03df9bb7eec1.jpg", // IMG_20260515_153119641_HDR.jpg
    features: ["Individuelt design", "Dræningsløsninger", "Niveauforskelle", "Kvalitetsfliser"],
    gallery: [
      "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/89e6d88b-15e9-4736-ad5b-8d20f155e9b5.jpg", // IMG_20260515_153052135.jpg
      "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/bc58fc7f-bbe4-4b2d-8df6-e42f24b3960e.jpg", // IMG_20260515_153033387.jpg
      "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/f6f8bba0-8cf5-4901-a9dd-19fbbb4228d3.jpg", // IMG_20260515_153027288.jpg
      "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/ccab3984-c9b9-4022-ac5e-7c7d9b43d2c8.jpg", // IMG_20260505_093128732.jpg
      "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/2f904968-10b4-4657-be65-2fe2a696fb33.jpg", // IMG_20260505_093101583.jpg
      "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/88e891d5-9298-48d1-9ed4-53a11f44ffeb.jpg", // IMG_20260505_093058063.jpg
      "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/80c1e3b3-2080-430e-ba26-768d207f88bf.jpg"  // forsidebaggrund.jpg
    ]
  },
  {
    id: 3,
    slug: "fliser",
    title: "Fliser",
    shortDescription: "Præcis fliselægning til stier, gangarealer og indgangspartier.",
    fullDescription: "Fliselægning kræver præcision og øje for detaljen. Jeg udfører alt arbejde inden for fliser – fra de små havegange til de store parkeringsarealer. Jeg arbejder med alle typer betonfliser og natursten, og jeg garanterer et resultat, hvor fugerne sidder lige og overfladen er jævn.",
    icon: "LayoutGrid",
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/28ae4412-cb2e-473c-a38a-b3d1feeec17a.jpg", // IMG_20260407_160503361_HDR.jpg
    features: ["Præcisionsarbejde", "Alle flisetyper", "Reparation og nyanlæg", "Professionel rådgivning"],
    gallery: [
      "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/7bd1a850-a412-417c-9658-b1d936a4652c.jpg", // IMG_20260407_160440054_HDR.jpg
      "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/b684343d-7fde-4ab1-931d-8a48bff284cb.jpg", // IMG_20260328_182545621.jpg
      "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/7fbda8cb-2986-47a1-8c11-59e1e4c88de5.jpg", // IMG_20260328_182538437_HDR.jpg
      "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/e72862b6-f5f1-49b2-b513-319c2269a1fc.jpg", // IMG_20260328_182532972.jpg
      "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/884b1987-2a1e-47a5-a884-eafedfa7b16c.jpg", // IMG_20260328_182509648.jpg
      "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/dffc831d-a886-4779-96f3-1661a77ca2a5.jpg", // IMG_20260328_182500317_HDR.jpg
      "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/bbdab6b7-f365-4a59-b633-8451c41a7de5.jpg", // IMG_20260328_182449119_HDR.jpg
      "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/7aacf1fd-441a-4c8a-8e7d-de522eb728d9.jpg", // IMG_20260328_182445340_HDR.jpg
      "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/5dc66f41-29e3-47d3-b516-f8f87b65c555.jpg", // IMG_20260102_121015164_HDR.jpg
      "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/f55617d8-39cc-4ae0-8e72-e60e1f27da28.jpg", // IMG_20260102_121006109.jpg
      "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/be972632-5afc-46ef-8b26-66160b96d660.jpg", // IMG_20251119_154658520.jpg
      "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/653b94aa-0a64-4807-80b9-ab09e632c32d.jpg"  // IMG_20251107_095917177.jpg
    ]
  },
  {
    id: 4,
    slug: "anlaegsgartner",
    title: "Anlægsgartner",
    shortDescription: "Komplet haveanlæg, fra belægning til beplantning og græsplæner.",
    fullDescription: "Som din anlægsgartner tager jeg hånd om hele uderummet. Jeg kombinerer brolægning med det grønne element, så du får en harmonisk have. Jeg tilbyder alt fra rullegræs og beplantningsplaner til fældning og beskæring, så din have bliver en komplet oase.",
    icon: "TreePine",
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/86d79315-f3d5-4ef1-a94f-4f1d079dd33a.jpg", // 1000003434.jpg
    features: ["Havearkitektur", "Rullegræs", "Beplantning", "Totalentreprise"],
    gallery: [
      "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/fae96d08-be67-4d22-b758-0c6164469799.jpg", // IMG_20260514_094129634.jpg
      "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/fba1535d-a288-499f-a700-9e9bc25c6326.jpg", // IMG_20260102_134750554.jpg
      "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/1bbc9c97-fb97-4fea-a122-97a3a7ba4a64.jpg", // IMG_20251206_155534306.jpg
      "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/380407e1-af4d-40e8-a988-a6dad0c14c84.jpg", // IMG_20251206_155522191.jpg
      "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/39c3c81b-e3db-4dcc-911e-edcf01013f86.jpg", // IMG_20251206_153749233.jpg
      "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/e1659de7-3e5e-4432-b1c6-f20fec40c408.jpg"  // IMG_20251031_164747099.jpg
    ]
  },
];

export const gallery = [
  // Anlægsgartner
  {
    id: 1,
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/f651e457-fb15-4c24-9f5c-15e782e6b83a.jpg",
    title: "Præcisionsarbejde ved indgangsparti og haveanlæg",
    category: "Anlægsgartner",
  },
  {
    id: 2,
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/fae96d08-be67-4d22-b758-0c6164469799.jpg",
    title: "Fliselægning og havegang omkring huset",
    category: "Anlægsgartner",
  },
  {
    id: 3,
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/fba1535d-a288-499f-a700-9e9bc25c6326.jpg",
    title: "Etablering af havemiljø og gangstier",
    category: "Anlægsgartner",
  },
  {
    id: 4,
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/1bbc9c97-fb97-4fea-a122-97a3a7ba4a64.jpg",
    title: "Nyanlagt græsplæne og kantafgrænsning",
    category: "Anlægsgartner",
  },
  {
    id: 5,
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/380407e1-af4d-40e8-a988-a6dad0c14c84.jpg",
    title: "Haveanlæg med flotte bede og belægning",
    category: "Anlægsgartner",
  },
  {
    id: 6,
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/39c3c81b-e3db-4dcc-911e-edcf01013f86.jpg",
    title: "Komplet haverenovering med nye fliser",
    category: "Anlægsgartner",
  },
  {
    id: 7,
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/e1659de7-3e5e-4432-b1c6-f20fec40c408.jpg",
    title: "Flot afslutning mod grønne arealer",
    category: "Anlægsgartner",
  },

  // Indkørsel
  {
    id: 8,
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/c44311e0-ab36-48d7-b71e-cf49ea50338d.jpg",
    title: "Nyanlagt indkørsel med flot mønster",
    category: "Indkørsel",
  },
  {
    id: 9,
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/bd078cb6-69a2-4457-8521-8c9349fd5f0c.jpg",
    title: "Brolægning af stor indkørsel foran garage",
    category: "Indkørsel",
  },
  {
    id: 10,
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/1570738f-fb1f-4b93-bb10-a902da24c142.jpg",
    title: "Indkørsel med herregårdssten og præcise fuger",
    category: "Indkørsel",
  },
  {
    id: 11,
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/4423a5b0-6d79-432f-9a1e-1ea914ba712d.jpg",
    title: "Flot belægningsmønster i nyanlagt indkørsel",
    category: "Indkørsel",
  },
  {
    id: 12,
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/184f5678-e82f-4a76-abd6-73a91f35f0c4.jpg",
    title: "Indkørsel og gangsti udført i herregårdssten",
    category: "Indkørsel",
  },
  {
    id: 13,
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/97b85d20-2fe2-44cb-bc04-9e4ed52f4054.jpg",
    title: "Afslutning og kantafgrænsning ved indkørsel",
    category: "Indkørsel",
  },

  // Fliser
  {
    id: 14,
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/28ae4412-cb2e-473c-a38a-b3d1feeec17a.jpg",
    title: "Præcisionsarbejde med store betonfliser",
    category: "Fliser",
  },
  {
    id: 15,
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/7bd1a850-a412-417c-9658-b1d936a4652c.jpg",
    title: "Fliselægning ved indgangsparti og trappetrin",
    category: "Fliser",
  },
  {
    id: 16,
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/b684343d-7fde-4ab1-931d-8a48bff284cb.jpg",
    title: "Flisegang langs husmuren med perfekt fald",
    category: "Fliser",
  },
  {
    id: 17,
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/7fbda8cb-2986-47a1-8c11-59e1e4c88de5.jpg",
    title: "Præcis tilskæring af fliser omkring hjørner",
    category: "Fliser",
  },
  {
    id: 18,
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/e72862b6-f5f1-49b2-b513-319c2269a1fc.jpg",
    title: "Flisearbejde ved carport og gangarealer",
    category: "Fliser",
  },
  {
    id: 19,
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/884b1987-2a1e-47a5-a884-eafedfa7b16c.jpg",
    title: "Flot mønster og lige fuger i flisebelægning",
    category: "Fliser",
  },
  {
    id: 20,
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/dffc831d-a886-4779-96f3-1661a77ca2a5.jpg",
    title: "Fliselægning ved terrasse og gangstier",
    category: "Fliser",
  },
  {
    id: 21,
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/bbdab6b7-f365-4a59-b633-8451c41a7de5.jpg",
    title: "Afslutning mod sokkel med præcise fliser",
    category: "Fliser",
  },
  {
    id: 22,
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/7aacf1fd-441a-4c8a-8e7d-de522eb728d9.jpg",
    title: "Brolægning foran huset med herregårdssten",
    category: "Fliser",
  },
  {
    id: 23,
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/5dc66f41-29e3-47d3-b516-f8f87b65c555.jpg",
    title: "Flot kurveforløb og mønster i belægning",
    category: "Fliser",
  },
  {
    id: 24,
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/f55617d8-39cc-4ae0-8e72-e60e1f27da28.jpg",
    title: "Flisearbejde ved indgang og trappe",
    category: "Fliser",
  },
  {
    id: 25,
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/be972632-5afc-46ef-8b26-66160b96d660.jpg",
    title: "Flisegang langs husmuren med herregårdssten",
    category: "Fliser",
  },
  {
    id: 26,
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/653b94aa-0a64-4807-80b9-ab09e632c32d.jpg",
    title: "Nyanlagt sti og flisebelægning i haven",
    category: "Fliser",
  },

  // Terrasse
  {
    id: 27,
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/c9bc5107-9e56-4f64-acbc-03df9bb7eec1.jpg",
    title: "Nyanlagt terrasse med herregårdssten",
    category: "Terrasse",
  },
  {
    id: 28,
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/89e6d88b-15e9-4736-ad5b-8d20f155e9b5.jpg",
    title: "Etablering af stor, flot terrasse",
    category: "Terrasse",
  },
  {
    id: 29,
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/bc58fc7f-bbe4-4b2d-8df6-e42f24b3960e.jpg",
    title: "Præcisionsarbejde ved trappetrin og terrasse",
    category: "Terrasse",
  },
  {
    id: 30,
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/f6f8bba0-8cf5-4901-a9dd-19fbbb4228d3.jpg",
    title: "Terrasse med herregårdssten under opbygning",
    category: "Terrasse",
  },
  {
    id: 31,
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/ccab3984-c9b9-4022-ac5e-7c7d9b43d2c8.jpg",
    title: "Stor fliseterrasse med perfekt afvanding",
    category: "Terrasse",
  },
  {
    id: 32,
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/2f904968-10b4-4657-be65-2fe2a696fb33.jpg",
    title: "Flot afslutning og kantafgrænsning på terrasse",
    category: "Terrasse",
  },
  {
    id: 33,
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/88e891d5-9298-48d1-9ed4-53a11f44ffeb.jpg",
    title: "Terrasse med herregårdssten og flot finish",
    category: "Terrasse",
  },
  {
    id: 34,
    image: "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/80c1e3b3-2080-430e-ba26-768d207f88bf.jpg",
    title: "Nyanlagt terrasse set fra oven",
    category: "Terrasse",
  }
];

export const companyInfo = {
  name: "Nielsen Brolægning",
  address: "Bøgvadvej 14",
  zipCity: "6040 Egtved",
  fullAddress: "Bøgvadvej 14, 6040 Egtved",
  phone: "42 36 10 65",
  email: "nielsenbrolaegning@outlook.dk",
  cvr: "42361065"
};

export const testimonials = [
  {
    id: 1,
    name: "Mads Hansen",
    text: "Nielsen Brolægning leverede et fantastisk stykke arbejde. Vores nye terrasse er præcis som vi drømte om.",
    location: "Roskilde",
  },
  {
    id: 2,
    name: "Sofie Jensen",
    text: "Professionel rådgivning og hurtig eksekvering. Kan varmt anbefales til alle brolægningsopgaver.",
    location: "Køge",
  },
];
